import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { initialsOf } from './avatar-initials';

export type AvatarSize = 'sm' | 'md' | 'lg';

/** sm 28px (top bar), md 42px (table rows), lg 49px, 70px on desktop (record pages). */
const SIZE_CLASSES: Record<AvatarSize, string> = {
    sm: 'w-8 h-8 text-label',
    md: 'w-12 h-12 text-base',
    lg: 'w-14 h-14 text-xl lg:w-20 lg:h-20 lg:text-3xl'
};

/**
 * Round avatar with the person's initials.
 * Decorative only: always print the name next to it.
 *
 * @example
 * <app-avatar [name]="user.name" size="lg" />
 */
@Component({
    selector: 'app-avatar',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './avatar.component.html'
})
export class AvatarComponent {
    readonly name = input.required<string | null | undefined>();
    readonly size = input<AvatarSize>('md');

    readonly initials = computed(() => initialsOf(this.name()));
    readonly sizeClass = computed(() => SIZE_CLASSES[this.size()]);
}
